import React, { useState, useEffect } from 'react';
import FlipClockCountdown from '@leenguyen/react-flip-clock-countdown';
import '@leenguyen/react-flip-clock-countdown/dist/index.css';
import moment from 'moment';
import './LeaderboardClock.css';
import { Col, Row } from 'react-bootstrap';
import batakPro from "../../Images/batak-pro-name.png"

const LeaderboardClock = () => {
  const calculateTimeState = () => {
    const now = moment();
    const startTime = moment().set({ hour: 10, minute: 0, second: 0 }); // 11:00 AM today
    const endTime = moment().set({ hour: 18, minute: 0, second: 0 }); // 6:00 PM today

    if (now.isBefore(startTime)) {
      return { displayTime: "08:00:00", countdownTime: null }; 
    }

    if (now.isBetween(startTime, endTime)) {
      return { displayTime: null, countdownTime: endTime.diff(now) }; // Countdown time remaining
    }

    // Case 3: After 6:00 PM, show 00:00:00
    return { displayTime: "00:00:00", countdownTime: null }; // Fixed time after 6 PM
  };

  const [timeState, setTimeState] = useState(calculateTimeState);

  useEffect(() => {
    // Update the time every second
    const timerInterval = setInterval(() => {
      setTimeState(calculateTimeState());
    }, 1000);

    // Clean up interval on component unmount
    return () => clearInterval(timerInterval);
  }, []);

  // Convert milliseconds to a Date object that FlipClockCountdown expects, only if countdownTime exists
  const endTime = timeState.countdownTime ? new Date(Date.now() + timeState.countdownTime) : null;
  

  return (
    <div className='leaderboard-clock'>
      {timeState.displayTime ? (
            <img src={batakPro} className="grabow-img mt-1" alt="grabow-img" />

      ) : (
        <Row>
          <Col xs={12} md={12} lg={12} className='d-flex justify-content-center'>
          <div className='leader-board-timer-container'>
        <h1>BATAK PRO CHALLENGE ENDS IN </h1>
        <FlipClockCountdown
          to={endTime}
          labelStyle={{ fontSize: 10, fontWeight: 500, textTransform: 'uppercase' }}
          digitBlockStyle={{ width: 60, height: 60, fontSize: 50, fontWeight: 'bold', background: 'white', color: '#6000d2' }}
          dividerStyle={{ color: 'white', height: 2 }}
          separatorStyle={{ color: 'black', size: '6px' }}
          renderMap={[false, true, true, true]} // Hours, Minutes, Seconds
          duration={0.5}
          className='flip-clock  justify-content-center '
          showLabels={false}
        />
        </div>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default LeaderboardClock;
